import React from 'react';

import { TalentIcon } from '@atlaskit/logo';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration, GlobalShortcutLinkItem } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';

import { messages } from './messages';

const icon = <TalentIcon size="xsmall" label="" />;

export const useTalent = (
	fallbackUrl: FallbackUrl,
	options: GlobalShortcutConfiguration = {},
): GlobalShortcutLinkItem =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.TALENT,
		analyticsName: Products.TALENT,
		...options,
	});
